export const stages = {
  staging: "staging",
  production: "production",
  other: "other",
};

export const getReleaseStage = () => {
  switch (location.hostname) {
    case "ilk-website-staging.c.simplificator.com":
      return stages.staging;
    case "parlamente.ch":
    case "parlements.ch":
    case "www.parlamente.ch":
    case "www.parlements.ch":
    case "ilk-website.c.simplificator.com":
    case "ilk-website.s.simplificator.com":
      return stages.production;
    default:
      return stages.other;
  }
};

export default getReleaseStage;
